var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"68b65b31068b5c81efbcacb6e512e2d65c8dc76a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@the-cumin-club"]={id:"68b65b31068b5c81efbcacb6e512e2d65c8dc76a"};
      